export function sortByProperty<T>(array: T[], property: keyof T, ascending?: boolean): T[] {
	return array.slice().sort((a, b) => {
		let comparison = 0
		if (a[property] > b[property]) comparison = 1
		else if (a[property] < b[property]) comparison = -1
		return ascending ? comparison : -comparison
	})
}
